import userHelper from 'utils/user'
import hasBillesAccess from 'utils/hasBillesAccess'

function prepareModuleFieldsForCurrentUser({ state }) {
  let { user, modules } = state.get('client')
  if (user) {
    let helper = userHelper(user)
    modules.forEach(module => {
      let options = module.groups.reduce((acc, group, index) => {
        if (!(!helper.isBilles() && hasBillesAccess(group.access))) {
          const { access, name } = group
          let option = {
            key: access,
            value: name,
            index
          }
          acc.push(option)
        }
        return acc
      }, [])
      state.merge(`client.registrating.current.modules.${module.module}`, {
        value: [],
        options
      })
    })
  }
}

export default prepareModuleFieldsForCurrentUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/prepareModuleFieldsForNewUser.js